import { createContext, useContext } from 'react';

/**
 * The card shell exposes an element on its title line that a card body can
 * render into.
 *
 * A card's own controls (a chart's value and its Ask LognAI button, say) belong
 * beside the title, but the shell owns the header and the card owns the state
 * that drives those controls. Passing the node down as context lets the body
 * portal into the header without lifting chart state into the page or having
 * the shell know anything about charts.
 */
export const CardHeaderSlotContext = createContext<HTMLElement | null>(null);

export const useCardHeaderSlot = () => useContext(CardHeaderSlotContext);
